<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;} 
.interact_right input.h_title{width: 60vw;margin: 0 auto;height: 5vw;display: block;border: 0;border-bottom: #ddd solid 1px;border-radius: 0;
font-size: 1.6vw;color: #3465ff;}
.interact_right input.h_title::placeholder{color: #3465ff;}
.interact_data_head{width: 60vw;height:5vw;border-bottom: #ddd solid 1px;}
.interact_data_head span{display: block;float: left;line-height: 5vw;font-size: 1.4vw;}
.interact_data_head span.m1{color: #999;}
.interact_data_head span.m2{color: #000;margin-left: 1vw;}
.interact_data_head span.m3{color: #c00;margin-left: 1vw;}
.interact_data_data{width: 60vw;margin: 0 auto;height: 7vw;padding:2vw 0;}
.interact_data_data ul li{width: 25%;float: left;border-left: #e5e5e5 solid 1px;box-sizing: border-box;}
.interact_data_data ul li:first-child{border: 0;}
.interact_data_data ul li span{display: block;text-align: center;}
.interact_data_data ul li span.d1{font-size: 4vw;font-weight: normal;font-family:Arial;line-height: 5vw;}
.interact_data_data ul li span.d2{font-size: 1.2vw;font-weight: normal;font-family:Arial;line-height: 2vw;}
.charts_title{width: 60vw;height: 3vw;}
.charts_title span{display: block;height: 3vw;line-height: 3vw;border-bottom: #3465ff solid 1px; float: left;}
.charts_div{width: 70vw;height: 25vw;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	 <div class="interact_data_head">
	     	 	<span class="m1">时间</span>
	     	 	<span class="m2">7天</span>
	     	 	<span class="m3">30天</span>
	     	 </div>
	     	 <div class="interact_data_data">
	     	 	<ul>
	     	 	   <li><span class="d1">5928</span><span class="d2">短信总发送人次</span></li>
	     	 	   <li><span class="d1">3991</span><span class="d2">信息阅读量</span></li>
	     	 	   <li><span class="d1">773</span><span class="d2">调查参与人次</span></li>
	     	 	   <li><span class="d1">9251</span><span class="d2">留言量</span></li>
	     	 	</ul>
	     	 </div>
	     	 <div class="charts_title"><span>信息阅读趋势图</span></div>
	     	 <div class="charts_div"><div id="mains" style="width: 100%; height: 100%"></div></div>
		 </div>

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:5,
				sub:"2",
				title:"内容数据",
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 

		},
		methods: {
		       drawChart() {
			      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
			      let myChart = this.$echarts.init(document.getElementById("mains"));
			      // 指定图表的配置项和数据
			      let option = {
					  xAxis: {
					    type: 'category',
					    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
					    {
					      data: [820, 932, 901, 934, 1290, 1330, 1320],
					      type: 'line',
					      smooth: true
					    }
					  ]
					};
			      // 使用刚指定的配置项和数据显示图表。
			      myChart.setOption(option);
			},
			vote_add(){
                   this.$router.push("/vote_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},mounted() {
		    this.drawChart();
		},
          watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/interact/data.vue